import { Button } from '@epidemicsound/design-system/v2'
import { FC } from 'react'
import { TabListContainer } from './TabListContainer'

interface TabListProps {
    tabs: ButtonTabListItemProps[]
    selectedTab: number
    handleMenuNav: (selectedTabIndex: number) => void
    size?: string
}

export interface ButtonTabListItemProps {
    label: string
}

export const ButtonTabList: FC<TabListProps> = ({
    tabs,
    selectedTab,
    handleMenuNav,
    ...props
}) => {
    return (
        <>
            <div {...props}>
                <TabListContainer>
                    {tabs.map((tab, i) => {
                        const variant =
                            tabs.length > 1 && selectedTab === i
                                ? 'primary'
                                : 'secondary'
                        return (
                            <Button
                                key={tab.label}
                                onClick={() => handleMenuNav(i)}
                                variant={variant}
                            >
                                {tab.label}
                            </Button>
                        )
                    })}
                </TabListContainer>
            </div>
        </>
    )
}
